import { Stack, Typography, useTheme } from "@mui/material";
import { FoodsIcon } from "@foodpilot/foods";

interface TopicHashtagLabelProps {
    name: string;
    /** Single line with ellipsis (sidebar) vs wrap (feed chips) */
    truncate?: boolean;
}

/** Hashtag label for community topics — distinct from post-type badges (no button shell). */
export const TopicHashtagLabel = ({ name, truncate = false }: TopicHashtagLabelProps) => {
    const theme = useTheme();

    return (
        <Stack direction="row" alignItems="flex-start" gap={0.5} minWidth={0}>
            <FoodsIcon icon="tag" size={1} />
            <Typography
                variant="small-bold"
                component="span"
                sx={{
                    color: theme.custom.grey[2800],
                    lineHeight: 1.35,
                    ...(truncate ?
                        {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }
                    :   {
                            wordBreak: "break-word",
                        }),
                }}
            >
                #{name}
            </Typography>
        </Stack>
    );
};
